import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Table } from 'react-bootstrap';
import { FaPlus, FaEdit } from 'react-icons/fa';
import Loader from '../components/Loader';
import { toast } from 'react-toastify';
import { useAuth } from '../contexts/AuthContext';

const StoreHouse = () => {
  const [stores, setStores] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingStore, setEditingStore] = useState(null);
  const [storeName, setStoreName] = useState('');
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(true);
  const { token } = useAuth();

  const handleShow = () => {
    setShowModal(true);
    setEditingStore(null);
    setStoreName('');
    setValidated(false);
  };

  const handleClose = () => {
    setShowModal(false);
    setEditingStore(null);
    setStoreName('');
    setValidated(false);
  };

  // Fetch stores on component mount
  useEffect(() => {
    fetchStores();
  }, []);

  const fetchStores = async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/stores', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (!response.ok) {
        throw new Error('Omborlarni yuklashda xatolik!');
      }
      const data = await response.json();
      setStores(data.items || []);
    } catch (err) {
      setStores([]);
      toast.error(err.message || 'Omborlarni yuklashda xatolik!');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    const url = editingStore ? `/api/stores/${editingStore.id}` : '/api/stores';
    const method = editingStore ? 'PUT' : 'POST';

    try {
      const response = await fetch(url, {
        method,
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ name: storeName }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Omborni saqlashda xatolik!');
      }

      await fetchStores();
      handleClose();
      toast.success(editingStore ? 'Ombor muvaffaqiyatli tahrirlandi!' : 'Ombor muvaffaqiyatli qo\'shildi!');
    } catch (err) {
      toast.error(err.message || 'Omborni saqlashda xatolik!');
    }
  };

  const handleEdit = (store) => {
    setEditingStore(store);
    setStoreName(store.name);
    setShowModal(true);
  };

  // Delete functionality has been removed as per requirements

  return (
    <div className="container-fluid p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Omborlar</h2>
        <Button variant="success" onClick={handleShow}>
          <FaPlus className="me-2" /> Ombor qo'shish
        </Button>
      </div>

      {loading ? (
        <Loader />
      ) : stores.length === 0 ? (
        <div className="alert alert-info text-center">Omborlar topilmadi</div>
      ) : (
        <div className="card">
          <div className="card-body">
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Ombor Nomi</th>
                  <th>Amallar</th>
                </tr>
              </thead>
              <tbody>
                {stores.map((store) => (
                  <tr key={store.id}>
                    <td>{store.id}</td>
                    <td>{store.name}</td>
                    <td>
                      <Button
                        variant="outline-success"
                        size="sm"
                        className="me-2"
                        onClick={() => handleEdit(store)}
                      >
                        <FaEdit className="me-1" /> Tahrirlash
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      )}

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {editingStore ? 'Omborni Tahrirlash' : 'Yangi Ombor Qo\'shish'}
          </Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="storeName">
              <Form.Label>Ombor Nomi</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ombor nomini kiriting"
                value={storeName}
                onChange={(e) => setStoreName(e.target.value)}
                required
              />
              <Form.Control.Feedback type="invalid">
                Iltimos ombor nomini kiriting.
              </Form.Control.Feedback>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Bekor qilish
            </Button>
            <Button variant="success" type="submit">
              {editingStore ? 'Yangilash' : 'Saqlash'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default StoreHouse;